import Chip from '@mui/material/Chip';
import { bands, renewalStatuses, attendanceStatuses, tiers } from '../theme';
import { useI18n } from '../i18n';

export default function StatusChip({ band }) {
  const { t } = useI18n();
  const key = bands[band] ? band : 'at_risk';
  return (
    <Chip
      label={t(`bands.${key}`)}
      size="small"
      sx={{ backgroundColor: bands[key].color, color: '#fff', fontWeight: 600, fontSize: 11 }}
    />
  );
}

export function RenewalChip({ status }) {
  const { t } = useI18n();
  const key = renewalStatuses[status] ? status : 'not_started';
  return (
    <Chip
      label={t(`renewalStatus.${key}`)}
      size="small"
      sx={{ backgroundColor: renewalStatuses[key].color, color: '#fff', fontWeight: 600, fontSize: 11 }}
    />
  );
}

export function AttendanceChip({ attendance }) {
  const { t } = useI18n();
  const hit = attendanceStatuses[attendance];
  // Sin respuesta todavía: se dibuja hueca para que se distinga de un veredicto.
  if (!hit) {
    return (
      <Chip
        label={t('sessionsLog.pending')}
        size="small"
        variant="outlined"
        sx={{ color: '#847782', borderColor: '#E4E0E2', fontWeight: 500, fontSize: 11 }}
      />
    );
  }
  return (
    <Chip
      label={t(`attendance.${attendance}`)}
      size="small"
      sx={{ backgroundColor: hit.color, color: '#fff', fontWeight: 600, fontSize: 11 }}
    />
  );
}

export function TierChip({ tier }) {
  const { t } = useI18n();
  const { bg, fg } = tiers[tier] || tiers.FREE;
  return (
    <Chip
      label={tier || t('common.dash')}
      size="small"
      sx={{
        backgroundColor: bg, color: fg, fontWeight: 600,
        fontSize: 9.5, letterSpacing: '0.11em', height: 19, borderRadius: '3px',
      }}
    />
  );
}
